import { IProfilePersonalDetailsApiResponse } from 'src/apis/profile/profilePersonalDetails.interfaces';
import { UserStatus } from 'src/views/modules/users/users.interfaces';
import { mockUserAction } from '../users/userAction';
import { GENDER } from 'src/apis/users/users.interfaces';
import { mockDocument } from '../documents/documentMock';
import { EMPLOYMENT_STATUS } from 'src/apis/staff/staff.interfaces';

export const mockProfileDetails: IProfilePersonalDetailsApiResponse = {
  id: '1234567890',
  instituteId: 'f4d37581-b92b-43f6-9e5f-c337ed71df91',
  userStatus: UserStatus.ACTIVE,
  actions: {
    created: mockUserAction,
    updated: mockUserAction,
  },
  lastActive: '2025-01-01',
  basicDetails: {
    id: '1234567890',
    primaryDetails: {
      firstName: 'Rajesh',
      middleName: null,
      lastName: 'Mehta',
      gender: GENDER.MALE,
      emergencyContact: {
        firstName: 'Sunita',
        middleName: null,
        lastName: 'Mehta',
        gender: GENDER.FEMALE,
        relationship: 'Wife',
        phone: {
          countryCode: '+91',
          phoneNumber: '9876543210',
          isVerified: true,
        },
        email: { email: 'sunita.mehta@example.com', isVerified: true },
        address: {
          address1: '123 Mumbai Street',
          address2: 'Apartment 4B',
          city: 'Mumbai',
          state: 'Maharashtra',
          country: 'India',
          postalCode: '400001',
        },
      },
    },
    addressDetails: {
      address1: '123 Mumbai Street',
      address2: 'Apartment 4B',
      city: 'Mumbai',
      state: 'Maharashtra',
      country: 'India',
      postalCode: '400001',
    },
    contactDetails: {
      phone: {
        countryCode: '+91',
        phoneNumber: '9876543210',
        isVerified: true,
      },
      email: { email: 'rajesh.mehta@institute.edu', isVerified: true },
    },
  },
  professionalDetails: {
    id: '1234567890',
    employmentHistory: [
      {
        id: 'emp-1',
        isCurrent: true,
        designation: 'Senior Mathematics Teacher',
        department: 'Mathematics',
        joiningDate: '2020-01-01',
        employmentStatus: EMPLOYMENT_STATUS.ACTIVE,
        actions: {
          created: mockUserAction,
          updated: mockUserAction,
          deleted: undefined,
        },
      },
      {
        id: 'emp-2',
        isCurrent: false,
        designation: 'Mathematics Teacher',
        department: 'Mathematics',
        joiningDate: '2018-06-01',
        employmentStatus: EMPLOYMENT_STATUS.INACTIVE,
        actions: {
          created: mockUserAction,
          updated: mockUserAction,
          deleted: undefined,
        },
      },
      {
        id: 'emp-3',
        isCurrent: false,
        designation: 'Assistant Teacher',
        department: 'Mathematics',
        joiningDate: '2015-01-01',
        employmentStatus: EMPLOYMENT_STATUS.INACTIVE,
        actions: {
          created: mockUserAction,
          updated: mockUserAction,
          deleted: undefined,
        },
      },
    ],
    supervisor: {
      id: 'supervisor-1',
      firstName: 'Priya',
      middleName: null,
      lastName: 'Sharma',
      gender: GENDER.FEMALE,
      contactDetails: {
        phone: {
          countryCode: '+91',
          phoneNumber: '9123456789',
          isVerified: true,
        },
        email: { email: 'priya.sharma@institute.edu', isVerified: true },
      },
    },
    actions: { created: mockUserAction, updated: mockUserAction },
    qualifications: [
      {
        id: 'qual-1',
        degree: 'Master of Science',
        institution: 'Delhi University',
        specialization: 'Mathematics',
        passingYear: 2015,
        gradeOrPercentage: '85%',
        document: mockDocument,
      },
      {
        id: 'qual-2',
        degree: 'Bachelor of Science',
        institution: 'Mumbai University',
        specialization: 'Mathematics',
        passingYear: 2013,
        gradeOrPercentage: '82%',
        document: mockDocument,
      },
    ],
    certifications: [
      {
        id: 'cert-1',
        name: 'Certification in Advanced Mathematics Teaching',
        authority: 'National Council for Teacher Education',
        issuedOn: '2020-01-01',
        validTill: '2025-01-01',
        certificate: mockDocument,
      },
      {
        id: 'cert-2',
        name: 'Certification in Educational Technology',
        authority: 'Central Board of Secondary Education',
        issuedOn: '2021-06-01',
        validTill: '2026-06-01',
        certificate: mockDocument,
      },
    ],
    teachingProfile: {
      subjects: ['Mathematics', 'Statistics'],
      grades: ['9', '10', '11', '12'],
      isClassTeacher: true,
      classTeacherOf: ['10-A'],
    },
  },
};
